import React from 'react'
import ClientTags from '../../client/ClientTags'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientTagsPage() {
  return (
    <V3ProfileRouteShell>
      <ClientTags />
    </V3ProfileRouteShell>
  )
}

